var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import ImageHelper from '../../core/helpers/image-helper';
var ResizedPhoto = /** @class */ (function (_super) {
    __extends(ResizedPhoto, _super);
    function ResizedPhoto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.imageElement = null;
        _this.wrapperElement = null;
        _this.state = {
            status: 'unloaded',
            wrapperWidth: null,
            wrapperHeight: null,
        };
        return _this;
    }
    ResizedPhoto.prototype.componentDidMount = function () {
        this.handleWindowResize = this.handleWindowResize.bind(this);
        window.addEventListener('resize', this.handleWindowResize);
    };
    ResizedPhoto.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    ResizedPhoto.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (ref) { return _this.setWrapperRef(ref); }, className: "c-resized-photo__wrapper" }, this.renderImage()));
    };
    ResizedPhoto.prototype.renderImage = function () {
        var _this = this;
        return (React.createElement("img", { ref: function (element) { return _this.setImageRef(element); }, onLoad: function () { return _this.handleImageLoaded(); }, className: "c-resized-photo", src: this.props.photo.getUri(), alt: "", style: this.getImageStyle() }));
    };
    ResizedPhoto.prototype.handleImageLoaded = function () {
        this.setState({ status: 'loaded' });
    };
    ResizedPhoto.prototype.getImageStyle = function () {
        var imageSize = this.getScaledImageSize();
        if (!imageSize) {
            return {};
        }
        var ratio = this.getImageRatio();
        if (!ratio) {
            return {};
        }
        var userPositionX = this.props.photo.position_x * ratio;
        var userPositionY = this.props.photo.position_y * ratio;
        return {
            width: imageSize.width + "px",
            height: imageSize.height + "px",
            marginLeft: imageSize.width / 2 * -1 + userPositionX + "px",
            marginTop: imageSize.height / 2 * -1 + userPositionY + "px",
            transform: "rotate(" + this.props.photo.rotate + "deg",
        };
    };
    ResizedPhoto.prototype.getImageSize = function () {
        if (!this.imageElement) {
            return null;
        }
        var ratio = this.getImageRatio();
        if (!ratio) {
            return null;
        }
        var newWidth = this.imageElement.naturalWidth * ratio;
        var newHeight = this.imageElement.naturalHeight * ratio;
        return {
            width: newWidth,
            height: newHeight,
        };
    };
    ResizedPhoto.prototype.getScaledImageSize = function () {
        var imageSize = this.getImageSize();
        if (!imageSize) {
            return null;
        }
        var width = imageSize.width * this.props.photo.scale;
        var height = imageSize.height * this.props.photo.scale;
        return {
            width: width,
            height: height,
        };
    };
    ResizedPhoto.prototype.getImageRatio = function () {
        var wrapperWidth = this.state.wrapperWidth;
        var wrapperHeight = this.state.wrapperHeight;
        if (!wrapperWidth || !wrapperHeight) {
            return null;
        }
        if (!this.imageElement) {
            return null;
        }
        if (!this.imageElement.naturalWidth || !this.imageElement.naturalHeight) {
            return null;
        }
        return ImageHelper.getRatioByWindowSize(this.imageElement.naturalWidth, this.imageElement.naturalHeight, wrapperWidth, wrapperHeight, this.props.photo.rotate);
    };
    ResizedPhoto.prototype.setImageRef = function (element) {
        if (this.imageElement) {
            return;
        }
        this.imageElement = element;
        if (this.props.setImageRef) {
            this.props.setImageRef(element);
        }
    };
    ResizedPhoto.prototype.setWrapperRef = function (element) {
        if (!element) {
            return;
        }
        this.updateWrapperDimensions(element);
        if (this.wrapperElement) {
            return;
        }
        this.wrapperElement = element;
    };
    ResizedPhoto.prototype.handleWindowResize = function () {
        if (!this.wrapperElement) {
            return;
        }
        this.updateWrapperDimensions(this.wrapperElement);
    };
    ResizedPhoto.prototype.updateWrapperDimensions = function (element) {
        if (!element) {
            return;
        }
        if (this.state.wrapperWidth === element.clientWidth && this.state.wrapperHeight === element.clientHeight) {
            return;
        }
        this.setState({
            wrapperWidth: element.clientWidth,
            wrapperHeight: element.clientHeight,
        });
    };
    return ResizedPhoto;
}(React.Component));
export default ResizedPhoto;
